<script lang="ts">
  import { visualizationDataStore } from "../data-views/stores";
  import FaArrowsAltH from "svelte-icons/fa/FaArrowsAltH.svelte";
  import FaExpand from "svelte-icons/fa/FaExpand.svelte";
  import FaRegTimesCircle from "svelte-icons/fa/FaRegTimesCircle.svelte";
  import FaPlusSquare from "svelte-icons/fa/FaPlusSquare.svelte";
  import { slide } from "svelte/transition";
  import Button from "./button.svelte";
  import Loader from "./loader.svelte";
  import IconDropdown from "../ui-components/icon-dropdown.svelte";
  import Modal from "./modal.svelte";
  import { t } from "../translations/i18n";
  import { HorizontalResize, VerticalResize } from "../data-views/options";
  import { tooltip } from "svooltip";
  import { tick } from "svelte";
  import "svooltip/styles.css";

  export let showLoader: boolean = false;
  export let selectorDisabled: boolean = false;
  export let showModal: boolean = false;
  export let visualizationId: string;
  export let visualizationData: any

  let isFullScreen: boolean = false;
  let showSelector: boolean = true;
  let visualizationSize: string = "h-large-v-small"
  let visualizationHSize: any = HorizontalResize.LARGE;
  let visualizationVSize: any = VerticalResize.VERTICAL_SMALL;
  let contentButton: string = $t("Add content");
  let headerFocused: boolean = false;

  if (visualizationData.length == 0) {}
  else {
    if (visualizationData.type == "Figure") contentButton = $t("Edit content");
    visualizationSize = visualizationData.visualizationSize;
    let sizes = visualizationData.visualizationSize.split("-");
    let hSize = sizes[1];
    let vSize = sizes[3];
    switch (hSize) {
      case "large":
        visualizationHSize = HorizontalResize.LARGE;
        break;
      case "medium":
        visualizationHSize = HorizontalResize.MEDIUM;
        break;
      case "small":
        visualizationHSize = HorizontalResize.SMALL;
        break;
    }
    switch (vSize) {
      case "large":
        visualizationVSize = VerticalResize.VERTICAL_LARGE;
        break;
      case "small":
        visualizationVSize = VerticalResize.VERTICAL_SMALL;
        break;
    }
  }

  $: if (showLoader) {
    showSelector = false;
  }

  const selectorHandler = (): void => {
    showSelector = !showSelector;
  };

  
  const horizontalSizeHandler = (changedSize: any): void => {
    switch (changedSize) {
      case HorizontalResize.SMALL:
        visualizationHSize = HorizontalResize.SMALL;
        if (visualizationVSize == VerticalResize.VERTICAL_SMALL){
          visualizationSize = "h-small-v-small";
        }
        else if (visualizationVSize == VerticalResize.VERTICAL_LARGE){
          visualizationSize = "h-small-v-large";
        }
        break;

      case HorizontalResize.MEDIUM:
        visualizationHSize = HorizontalResize.MEDIUM;
        if (visualizationVSize == VerticalResize.VERTICAL_SMALL){
          visualizationSize = "h-medium-v-small";
        }
        else if (visualizationVSize == VerticalResize.VERTICAL_LARGE){
          visualizationSize = "h-medium-v-large";
        }
        break;
      case HorizontalResize.LARGE:
        visualizationHSize = HorizontalResize.LARGE;
        if (visualizationVSize == VerticalResize.VERTICAL_SMALL){
          visualizationSize = "h-large-v-small";
        }
        else if (visualizationVSize == VerticalResize.VERTICAL_LARGE){
          visualizationSize = "h-large-v-large";
        }
        break;
      }
    // Update visualization data store with the new size
    visualizationDataStore.updateVisualizationSize(visualizationId, visualizationSize)
    handleResizing();
  };

  const verticalSizeHandler = (changedSize: any): void => {
    switch (changedSize) {
      case VerticalResize.VERTICAL_SMALL:
        visualizationVSize = VerticalResize.VERTICAL_SMALL;
        if (visualizationHSize == HorizontalResize.SMALL){
          visualizationSize = "h-small-v-small";
        }
        else if (visualizationHSize == HorizontalResize.MEDIUM){
          visualizationSize = "h-medium-v-small";
        }
        else if (visualizationHSize == HorizontalResize.LARGE){
          visualizationSize = "h-large-v-small";
        }
        break;

      case VerticalResize.VERTICAL_LARGE:
        visualizationVSize = VerticalResize.VERTICAL_LARGE;
        if (visualizationHSize == HorizontalResize.SMALL){
          visualizationSize = "h-small-v-large";
        }
        else if (visualizationHSize == HorizontalResize.MEDIUM){
          visualizationSize = "h-medium-v-large";
        }
        else if (visualizationHSize == HorizontalResize.LARGE){
          visualizationSize = "h-large-v-large";
        }
        break;
      }
    // Update visualization data store with the new size
    visualizationDataStore.updateVisualizationSize(visualizationId, visualizationSize)
    handleResizing();
  };

  const fullScreenHandler = (): void => {
    isFullScreen = !isFullScreen;
    handleResizing();
  };

 
  const handleResizing = (): void => {
    container.style.transition = "width 400ms ease";
    // Wait for the transition to finish and dispatch resize event for data
    // visualization components to update their size
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
      // Do not use transition on window resize to as visualization
      // components update their size immediately
      container.style.removeProperty("transition");
    }, 401);
  };

  const removeHandler = (): void => {
    showModal = true;
  };

  const modalCancelHandler = (): void => {
    showModal = false;
  };

  
  const removeVisualization = (): void => {
    visualizationDataStore.removeVisualization(visualizationId);
    container.style.transition = "height 400ms ease";
    container.style.height = "0px";
    setTimeout(() => {
      container?.parentNode?.removeChild(container);
    }, 200);
  };

  let container: HTMLElement;

  /**
   * Handle keyboard events
   * @param event - The keyboard event
   * @returns void
  */
  const onKeyDown = async (event: KeyboardEvent): Promise<void> => {
    await tick();

    const interactiveElements = Array.from(document.querySelectorAll('#header-id-' + visualizationId + ' [tabindex="0"]'));

    // add children on the Buttons to the interactiveElements
    const buttons = Array.from(document.querySelectorAll('#headerButtons-' + visualizationId)[0].childNodes) as HTMLElement[];

    // add buttons to the interactiveElements if it is div and don't add the duplicated elements
    buttons.forEach((button) => {
      if (button.tagName === 'DIV' && !interactiveElements.includes(button)) {
        interactiveElements.push(button);
      }
    });
    let currentIndex = interactiveElements.indexOf(document.activeElement as HTMLElement);

    switch (event.key) {
      case "Enter":
        // Just click on the elements in the interactiveElements array
        if (headerFocused) {
          (document.activeElement as HTMLElement).click();
        }
        if (showModal) {
          await tick();
          // Set focus to the cancel button
          (document.querySelector('#remove-container-cancel') as HTMLElement).focus();
        }
        break;

      case "ArrowDown":
        // Just when the focus is on the container, the first filter selector will be focused
        const activeElement = document.activeElement as HTMLElement;
        if (activeElement.id === container.id || activeElement.id === ("edit-content-button-" + visualizationId)){
          await tick();
          let firstFilterSelector = container.querySelectorAll('[id^="filterPropsContainer"]');
          // Prevent page scrolling on arrow down
          document.querySelector("body")?.setAttribute("style", "overflow-y: hidden;");
          if (firstFilterSelector.length > 0) {
            // Set focus to the first filter selector
            (firstFilterSelector[0] as HTMLElement)?.focus();
            return;
          } else {
            // Set focus to the first header element
            (interactiveElements[0]as HTMLElement).focus();
          }
        }
        if (interactiveElements.includes(document.activeElement as HTMLElement)) {
          headerFocused = true;
        } else {
          headerFocused = false;
        }
        break;

      case "ArrowRight":
        if (headerFocused) {
          currentIndex = (currentIndex + 1) % interactiveElements.length;
          (interactiveElements[currentIndex] as HTMLElement).focus();
        }
        if (showModal) {
          // Set focus to the cancel button
          (document.querySelector('#remove-container-cancel') as HTMLElement).focus();
        }
        break;

      case "ArrowLeft":
        if (headerFocused) {
          currentIndex = (currentIndex - 1 + interactiveElements.length) % interactiveElements.length;
          (interactiveElements[currentIndex] as HTMLElement).focus();
        }
        if (showModal) {
          // Set focus to the cancel button
          (document.querySelector('#remove-container-ok') as HTMLElement).focus();
        }
          break;

      case "Tab":
        if (document.activeElement === container) {
          (interactiveElements[0] as HTMLElement).focus();
          headerFocused = true;
        } else {
          headerFocused = true;
          // navigate through the interactive elements
          currentIndex = (currentIndex + 1) % interactiveElements.length;
          (interactiveElements[currentIndex] as HTMLElement).focus();
          // if the last element is focused, focus on the next visualization
          if (currentIndex === interactiveElements.length - 2) {
            const nextVisualization = document.querySelector('#container-id-' + visualizationId)?.nextElementSibling as HTMLElement;
            if (nextVisualization) {
              nextVisualization.focus();
            } else {
              const addVisualizationButton = document.querySelector('#add-visualization-container')?.firstChild as HTMLElement;
              addVisualizationButton.focus();
            }
          }
        }
        break;

      default:
        // Allow default behavior for other keys
        return;
    }

    // Enable page scrolling after the arrow is pressed
    document.querySelector("body")?.setAttribute("style", "overflow-y: scroll;");

    // Prevent default behavior only for relevant keys
    event.preventDefault();
  };

</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-noninteractive-tabindex -->
<div
  bind:this={container}
  id = "container-id-{visualizationId}"
  class="container {visualizationSize.toLowerCase()} {isFullScreen ? 'full-screen' : ''}"
  data-testid="visualization-container-test"
  tabindex="0"
  on:keydown={onKeyDown}
>
  {#if showLoader}
    <Loader visible={showLoader} />
  {/if}
  <header id="header-id-{visualizationId}">
    <nav>
      <div class="select-content-button" data-testid="content-test">
        <Button
          handler={selectorHandler}
          title={contentButton}
          disabled={selectorDisabled}
          id="edit-content-button-{visualizationId}"
        >
          <FaPlusSquare slot="icon" />
          <svelte:fragment slot="text">{contentButton}</svelte:fragment>
        </Button>
      </div>
      <div class="buttons" id="headerButtons-{visualizationId}">
        <slot name="buttons" />
        {#if !isFullScreen}
          <div class="size-dropdown">
            <IconDropdown
              options={HorizontalResize}
              handler={horizontalSizeHandler}
              title={$t("Horizontal Size")}
              disabled={false}
            >
              <div class="icon" slot="icon"><FaArrowsAltH /></div>
            </IconDropdown>
          </div>
          <div class="size-dropdown">
            <IconDropdown
              options={VerticalResize}
              handler={verticalSizeHandler}
              title={$t("Vertical Size")}
              disabled={false}
            >
              <div class="vertical-icon" slot="icon"><FaArrowsAltH /></div>
            </IconDropdown>
          </div>
        {/if}
        <div class="icon" tabindex="0" on:click={fullScreenHandler} title={$t("Full screen")}
        use:tooltip={{
          content: $t("Full screen"),
          placement: 'top',
          delay: [250, 0],
          offset: 15,
          html: true,
          target: 'div.icon',
        }}>
          <FaExpand />
        </div>
        <div class="icon remove" tabindex="0" on:click={removeHandler} title={$t("Remove")}
        use:tooltip={{
          content: $t("Remove"),
          placement: 'top',
          delay: [250, 0],
          offset: 15,
          html: true,
          target: 'div.icon',
        }}>
          <FaRegTimesCircle />
        </div>
      </div>
    </nav>
  </header>

  <div class="main" id="main-id-{visualizationId}">
    {#if showSelector}
      <div transition:slide={{ duration: 400 }} class="selector" id="selector-id-{visualizationId}">
        <slot name="selector" />
      </div>
    {/if}
    <div style={showSelector ? "display:none" : ""} class="content">
      <slot name="content" />
    </div>
  </div>

  {#if showModal}
    <Modal okHandler={removeVisualization} cancelHandler={modalCancelHandler}>
        <svelte:fragment slot="content">
            <h2>{$t("Are you sure you want to remove this visualization?")}</h2>
            <p>
              {$t("This action cannot be undone. All the data associated with this visualization will be lost.")}
            </p>
        </svelte:fragment>
    </Modal>
  {/if}
</div>

<style lang="scss">
  @import "../scrollbars";

  .container {
    --header-height: 4.5rem;
    transition: ease-in-out 200ms;
    width: var(--visualization-width);
    height: 350px;//var(--visualization-height);
    position: relative;
    color: var(--color-gray-dark);
    background-color: var(--color-white);
    overflow: auto;

    header {
      position: sticky;
      height: var(--header-height);
      top: 0;
      left: 0;
      z-index: 10;
      display: none; // Header is not displayed before choosing stats and fields
      align-items: center;
      background-color: var(--color-white);

      nav {
        flex: 1;
        display: flex;
        justify-content: space-between;
        gap: 2rem;
        margin: 0 2rem;

        .select-content-button {
          :global(.text) {
            @media screen and (max-width: 500px) {
              display: none;
            }
          }
        }

        .buttons {
          display: flex;
          align-items: center;
          gap: 1rem;
          color: var(--color-gray);

          // affect inside the buttons slot
          :global(.icon) {
            width: 1.25rem;
            height: 1.25rem;
          }
          
          // For vertical size dropdown icon
          :global(.vertical-icon) {
            width: 1.25rem;
            height: 1.25rem;
            transform: rotate(90deg);
          }

          .remove {
            color: var(--color-tertiary);
          }

          @media screen and (max-width: 768px) {
            /* Apply styles for mobile screens */
            .size-dropdown {
              display: none;
            }
          }
        }
      }
    }

    .main {
      position: relative;
      overflow: hidden;
      height: 350px; // Default value for container. Will be replaced in visualisation script
      box-sizing: border-box;
      padding: 0 2rem 1rem;

      @include scrollbars;

      .selector {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 9; // Keep under the header so that menus open on top

        min-width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 1rem 2rem; // Keep the same padding as the main

        @include scrollbars;

        background-color: #232124;
        color: var(--color-white);
      }

      .content {
        height: 100%;
      }
    }

    // Sizes for the container
    &.h-small-v-small {
      width: 32.6924%;
      --visualization-height: 400px;

      .select-content-button {
        :global(.text) {
          display: none;
        }
        :global(#edit-content-button) {
          padding: 10px 12px;
        }
      }
    }
    &.h-medium-v-small {
      width: 66.347%;
      --visualization-height: 400px;
    }
    &.h-large-v-small {
      width: 100%;
      --visualization-height: 400px;
    }
    &.h-small-v-large {
      width: 32.6924%;
      --visualization-height: 855px;

      .select-content-button {
        :global(.text) {
          display: none;
        }
        :global(#edit-content-button) {
          padding: 10px 12px;
        }
      }
    }
    &.h-medium-v-large {
      width: 66.347%;
      --visualization-height: 855px;
    }
    &.h-large-v-large {
      width: 100%;
      --visualization-height: 855px;
    }

    @media screen and (max-width: 768px) {
      &.h-small-v-small, &.h-medium-v-small, &.h-large-v-small, &.h-small-v-large, &.h-medium-v-large, &.h-large-v-large{
        width: 100%;
        --visualization-height: 400px;
      }
    }

    &.full-screen {
      position: fixed;
      top: 70px;
      bottom: 0;
      left: 0;
      right: 0;
      width: 100%;
      --visualization-height: calc(100% - var(--header-height));
      z-index: 100;
      overflow: hidden;

      .main {
        height: calc(100% - var(--header-height));
      }
    }

    @include scrollbars;
  }
</style>
